import { render, staticRenderFns } from "./TraxUiStructActions.vue?vue&type=template&id=608a5460"
import script from "./TraxUiStructActions.vue?vue&type=script&lang=js"
export * from "./TraxUiStructActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports